import { createSelector } from 'reselect';

export const getNotifications = state => state.notifications;

export default createSelector(getNotifications, notifications => ({ notifications: notifications.reverse() }));